<template>
  <div
    v-if="error"
    class="error-template"
  >
    <div class="error-template__content">
      <i :class="`error-template__icon ${errorIcon}`" />
      <span class="error-template__text">
        {{ displayOnTwoLines($t(errorMessageKey, [errorParams])) }}
      </span>
    </div>
  </div>
</template>

<script lang="ts">
import { getFormattedErrorParams } from '~/services/errors'
import {
  ERROR_KEYS_BY_CODE,
  ERROR_CODES,
  ERROR_DETAILS_BY_CODE
} from '~/constants/errors'

export default {
  name: 'ModuleErrorTemplate',
  props: {
    error: {
      type: Object as PropType<Error>,
      default: null
    }
  },
  computed: {
    errorCode() {
      if (!this.error) {
        return undefined
      }

      const errorType = Object.entries(ERROR_KEYS_BY_CODE).find(
        ([_, errorKey]) => this.error.message.includes(errorKey)
      )
      return errorType ? (errorType[0] as ERROR_CODES) : undefined
    },
    errorIcon() {
      if (this.errorCode) {
        return ERROR_DETAILS_BY_CODE[this.errorCode].icon
      }
      return 'icon-error'
    },
    errorMessageKey() {
      if (this.errorCode) {
        return ERROR_DETAILS_BY_CODE[this.errorCode].messageKey
      }
      return 'dashboard.error.unknown'
    },
    errorParams() {
      if (this.errorCode) {
        return getFormattedErrorParams(this.error, this.errorCode)
      }
      return null
    }
  },
  methods: {
    displayOnTwoLines(text: string) {
      const textArray = text.split(' ')
      textArray.splice(textArray.length / 2, 0, '\n')
      return textArray.join(' ')
    }
  }
}
</script>

<style lang="scss" scoped>
.error-template {
  height: 100%;
  margin: 8px 8px 0 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  align-self: center;

  &__content {
    display: flex;
    justify-content: center;
    align-items: center;
    word-break: break-word;
  }

  &__icon {
    @include font-icon;
    @include font-size(24px);
    color: $text-secondary;
    margin-right: 10px;
  }

  &__text {
    @include font-text;
    @include font-size($font-size-mini);
    color: $text-tertiary;
    white-space: pre-line;
  }
}
</style>
